"use client";

import { PropsWithChildren, ReactNode } from "react";

export const DevOnly = ({
  children,
  fallback,
}: PropsWithChildren<{ fallback?: ReactNode }>) => {
  const isDev = process.env.NEXT_PUBLIC_ENV === "dev";
  if (!isDev) {
    return fallback || null;
  }
  return children;
};
